import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sh",
  "use": "icon-sh-usage",
  "viewBox": "0 0 4500 4078",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 4500 4078\" id=\"icon-sh\">\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol